import { render, staticRenderFns } from "./LandingPageAdmin.vue?vue&type=template&id=6950d745"
import script from "./LandingPageAdmin.vue?vue&type=script&lang=js"
export * from "./LandingPageAdmin.vue?vue&type=script&lang=js"
import style0 from "./LandingPageAdmin.vue?vue&type=style&index=0&id=6950d745&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports